import { createStore } from "vuex";

import adminsModule from "./modules/adminsModule";
import adminModule from "./modules/adminModule";
import categoriesModule from "./modules/categoriesModule";
import lessonsModule from "./modules/lessonsModule";
import ViewVideoModule from "./modules/ViewVideoModule"; // view video module
import notificationModule from "./modules/notificationModule"; // notification
import examsModule from "./modules/examsModule";
import infographModule from "./modules/infographModule";
import reviewModule from "./modules/reviewModule";
import codesModule from "./modules/codesModule";
import contactusModule from "./modules/contactusModule";
import postsModule from "./modules/postsModule";
import informationsModule from "./modules/informationsModule";
import bannersModule from "./modules/bannersModule";
import studentsModule from "./modules/studentsModule";
import classesModule from "./modules/classesModule";
import usersModule from "./modules/usersModule";
import offersModule from "./modules/offersModule";
import groupsModule from "./modules/groupsModule";
import analyticsModule from "./modules/analyticsModule";

const store = createStore({
  modules: {
    categoriesModule,
    lessonsModule,
    ViewVideoModule, // view video module
    notificationModule, // notification
    examsModule,
    infographModule,
    reviewModule,
    adminModule,
    adminsModule,
    codesModule,
    contactusModule,
    postsModule,
    informationsModule,
    bannersModule,
    studentsModule,
    classesModule,
    usersModule,
    offersModule,
    groupsModule,
    analyticsModule,
  },
});

export default store;
